import React from 'react';

import {
  Center, Flex, HStack, StackProps, Text,
} from '@chakra-ui/react';
import { useHistory, useParams } from 'react-router-dom';

import { Icon } from 'components';
import { relations } from 'constants/show';

interface RelationCardsProps extends StackProps {
    filterBy?: string
    filterValue?: string
}

export default function RelationsCards({ filterBy, filterValue, ...rest }: RelationCardsProps) {
  const { content } = useParams<GeneralRoute>();
  const { push } = useHistory();

  function RelationItem({ label, icon, key }) {
    return (
      <Flex
        onClick={() => {
          push(`/table/${key}?${filterBy}=${filterValue}`);
        }}
        cursor="pointer"
        flexDir="column"
        height={180}
        width={170}
        bg="white.default"
        shadow={2}
        _hover={{
          shadow: 3,
        }}
        borderRadius={8}>
        <Center
          p={5}
          pb={4}
          width="100%"
          borderBottomWidth={1}
          borderColor="gray.300">
          <Icon
            name={icon}
            color="primary.default"
            size="6xl"
          />
        </Center>
        <Center
          p={5}
          pt={4}>
          <Text
            color="gray.600"
            variant="largeBold">{label}
          </Text>
          <Icon
            color="gray.600"
            name="chevron-right"
            size="lg"
          />
        </Center>
      </Flex>
    );
  }

  if (!relations[content]) {
    return null;
  }

  return (
    <HStack
      spacing={2}
      {...rest}>
      {relations[content].map(RelationItem)}
    </HStack>
  );
}
